/** Create or update a tenant. */
export const tenantSaveSpec = {
    uri: '/t/[tenant]',
    method: 'PUT',
};
